// extracted by mini-css-extract-plugin
module.exports = {"darkFooter":"footer-module--darkFooter"};